import {Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class MeQuickTestService {

    constructor(
        public secureApi: SecureApi,
    ) {
       
    }

    createQuickTest(data) {
        return this.secureApi.post('b2c-quick-tests/create', data, false);
    }
}
